import { categorySlug } from '@shared/libs/category'
import { ENUM_SEO_SUBTYPE_WITH_STATS } from '@shared-submodule/sm-enum'
import CategoryContent from '@shared/components/categoryContent'
import TagPlayerTeamDetail from '@shared/components/tagPlayerTeamDetail'
import SeriesHome from '@shared/components/series/seriesHome'
import SeriesNews from '@shared/components/series/seriesNews'
import SeriesVideos from '@shared/components/series/seriesVideos'
import Fixtures from '@shared/components/series/fixtures'
import Standings from '@shared/components/series/standings'
import Stats from '@shared/components/series/stats'
import SeriesTeam from '@shared/components/series/seriesTeam'
import SeriesSquads from '@shared/components/series/seriesSquads'
import SeriesArchiveList from '@shared/components/series/seriesArchiveList'
// import SeriesFantasyTipsList from '@shared/components/series/seriesFantasyTipsList'

const useCategory = ({ category, seoData, currentSeriesData, rankingTabData }) => {
  const seriesUrls = {}
  category?.subPages?.forEach(e => {
    seriesUrls[ENUM_SEO_SUBTYPE_WITH_STATS[e?.eSubType]] = e?.sSlug
  })

  function getCategoryPages() {
    return (
      <CategoryContent
        tab={category?.type}
        seoData={seoData}
        reWriteURLS={category?.reWriteURLS}
        category={category?.data}
        tabSeo={category?.tabSeo}
        scoreCard={category?.seriesScoreCard}
        ssrNav={category?.subPages}
        showNav
        currentSeriesData={currentSeriesData}
        rankingTabData={rankingTabData}>
        {({ activeTab, changeTab }) => {
          if (category?.data?.eType === 's' || category?.data?.eType === 'fac' || category?.data?.eType === 'pct') {
            return <TagPlayerTeamDetail onTabChanges={changeTab} seoData={seoData} tag={category} activeTab={activeTab} />
          } else if (category?.data?.eType === 'as') {
            if (categorySlug.includes(category?.type)) {
              if (category.type === 'news') {
                return <SeriesNews data={category?.newsData} category={category?.data} />
              } else if (category.type === 'videos') {
                return <SeriesVideos data={category?.videosData} category={category?.data} />
              } else if (category.type === 'fixtures') {
                return (
                  <Fixtures
                    data={category?.fixturesData}
                    teamVenueData={category?.teamData}
                    id={category?.data?.iSeriesId}
                    seriesUrls={seriesUrls}
                  />
                )
              } else if (category.type === 'standings') {
                return (
                  <Standings
                    round={category?.roundData?.fetchSeriesRounds}
                    id={category?.data?.iSeriesId}
                    standing={category?.standingData?.fetchSeriesStandings}
                  />
                )
              } else if (category.type === 'stats') {
                return (
                  <Stats
                    data={category?.statsData}
                    matchTypeData={category?.matchTypeData?.listSeriesStatsFormat}
                    typeData={category?.seriesData}
                    id={category?.data?.iSeriesId}
                    seo={seoData}
                    statsDataBattingMostRuns={category?.statsDataBattingMostRuns}
                    statsDataBattingHighestStrikerate={category?.statsDataBattingHighestStrikerate}
                    statsDataBattingHighestAverage={category?.statsDataBattingHighestAverage}
                    statsDataBowlingTopWickeTakers={category?.statsDataBowlingTopWickeTakers}
                    statsDataBowlingBestEconomy={category?.statsDataBowlingBestEconomy}
                    statsDataBowlingBestAverages={category?.statsDataBowlingBestAverages}
                  />
                )
              } else if (category.type === 'teams') {
                return <SeriesTeam data={category?.seriesTeamData} id={category?.data?.iSeriesId} />
              } else if (category.type === 'squads') {
                return (
                  <SeriesSquads
                    team={category?.seriesTeamData?.listSeriesTeams?.aTeams}
                    players={category?.teamPlayer}
                    id={category?.data?.iSeriesId}
                  />
                )
              } else if (category.type === 'archives') {
                return <SeriesArchiveList id={category?.data?.iSeriesId} data={category?.seriesArchivesData?.listSeriesCTArchive} />
              } else return null
              // } else if (category.type === 'fantasy-tips') {
              //   return <SeriesFantasyTipsList data={category?.seriesFantasyTips} />
              // } else return null
              // else if (category.type === 'fantasy-articles') {
              //   return <SeriesFantasyArticle data={category?.fantasyArticle} category={category?.data} />
              // }
            } else {
              return (
                <SeriesHome
                  scoreCard={category?.seriesScoreCard}
                  data={category?.home}
                  playerData={category?.playerData?.listSeriesTopPlayers}
                  category={category?.data}
                  seriesUrls={seriesUrls}
                  seriesId={category?.data?.iSeriesId}
                />
              )
            }
          } else return null
        }}
      </CategoryContent>
    )
  }

  return {
    getCategoryPages
  }
}

export default useCategory
